import Vue from 'vue';

// Внимание! Спортсмены - это устройства в классификации Регатаскопа

export function getDevices() {
    return Vue.axios
        .get(`device`
        )
        .then(response => {
            console.log('return devices:' + response.data);
            return response.data;
        });
};

export function createDevice(data) {
    return Vue.axios
        .put(`gpxDevice`, data)
        .then(response => {
            return response;
        });
}

export function updateDevice(data) {
    return Vue.axios
        .post(`device`, data)
        .then(response => {
            return response;
        });
}
